import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
interface TestimonialCardProps {
  company: string;
  testimonial: string;
  author: string;
  title: string;
  logo: string;
  link: string;
  position?: string;
  years?: string;
}
const TestimonialCard: React.FC<TestimonialCardProps> = ({
  company,
  testimonial,
  author,
  title,
  logo,
  link,
  position,
  years
}) => {
  return <Link to={link} data-id="element-92">
      <motion.div className="bg-white rounded-lg shadow-lg p-6 h-full flex flex-col" whileHover={{
      scale: 1.05
    }} transition={{
      duration: 0.3
    }} data-id="element-93">
        <div className="flex items-center mb-2" data-id="element-94">
          <img src={logo} alt={`${company} logo`} className="w-12 h-12 object-contain mr-3" data-id="element-95" />
          <div data-id="element-96">
            <h3 className="text-xl font-bold text-gray-800" data-id="element-97">{company}</h3>
            {position && <p className="text-gray-600 text-sm" data-id="element-98">{position}</p>}
            {years && <p className="text-gray-500 text-xs" data-id="element-99">{years}</p>}
          </div>
        </div>
        <p className="text-gray-700 flex-grow mb-4 italic text-sm" data-id="element-100">
          {testimonial && `"${testimonial}"`}
        </p>
        <div className="mt-auto" data-id="element-101">
          <p className="font-bold text-gray-800" data-id="element-102">{author}</p>
          <p className="text-gray-600 text-sm" data-id="element-103">{title}</p>
        </div>
      </motion.div>
    </Link>;
};
export default TestimonialCard;